type PrimaryButtonProps = {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  variant?: 'primary' | 'secondary' | 'success'
  type?: 'button' | 'submit'
}

const variantClass = {
  primary:
    'h-12 min-h-12 w-full rounded-2xl bg-kilo-accent text-base font-semibold text-black transition-colors hover:bg-kilo-accent-dark active:opacity-90',
  secondary:
    'h-12 min-h-12 w-full rounded-2xl border border-kilo-border bg-kilo-nested text-base font-semibold text-kilo-text transition-colors hover:border-kilo-accent/40',
  success:
    'h-12 min-h-12 w-full rounded-2xl bg-kilo-accent text-base font-semibold text-black transition-colors hover:bg-kilo-accent-dark active:opacity-90',
}

const PrimaryButton = ({ children, onClick, disabled, variant = 'primary', type = 'button' }: PrimaryButtonProps) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`${variantClass[variant]} disabled:cursor-not-allowed disabled:opacity-60`}
  >
    {children}
  </button>
)

export default PrimaryButton
